import MenuItem from './MenuItem';
import { makeStyles } from '@material-ui/styles';
import { Theme, Text, BlockUserLine } from '@bizzabo/design-system';

const BanUserAction = ({ onBanClicked }) => {
    const classes = useStyles();
    return (
        <MenuItem onClick={onBanClicked}>
            <div className={classes.icon}>
                <BlockUserLine />
            </div>
            <Text variant="t81" className={classes.name}>
                Block attendee
            </Text>
        </MenuItem>
    );
};
const useStyles = makeStyles(
    (theme: Theme) => ({
        icon: { marginRight: 10, marginTop: 2, color: theme.palette.primary['600'] },
        name: { color: theme.palette.primary['600'] },
    }),
    {
        classNamePrefix: BanUserAction.name,
    }
);
export default BanUserAction;
